function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Heart({
  width = 37,
  height = 35,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.906 0c-3.935 0-7.081 3.11-9.036 5.17C16.873 3.126 13.67 0 9.743 0 3.993 0 0 4.212 0 10.253c0 13.116 16.52 23.924 17.251 24.36a2.384 2.384 0 002.604 0C20.555 34.16 37 23.3 37 10.262 36.943 3.93 33.484 0 27.906 0zM18.46 32.468S2.407 22.13 2.407 10.253c0-4.588 2.867-7.69 7.278-7.69 4.412 0 8.33 5.981 9.152 5.981.821 0 4.625-5.98 9.036-5.98 4.412 0 6.572 3.1 6.572 7.69.033 11.765-15.986 22.214-15.986 22.214z",
    fill: "#000"
  }));
}
//# sourceMappingURL=Heart.js.map